import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Marcela R.',
  age: 52,
  location: 'Bogotá, Colombia',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=faces',
  result: 'Perdí 6 kg en 8 semanas',
  quote: 'Llevaba 3 años con la barriga inflada y sin energía. Con el programa logré desinflamarme la primera semana, y a los 2 meses ya había perdido 6 kg sin pasar hambre. ¡Volví a verme al espejo!'
}, {
  name: 'Patricia V.',
  age: 48,
  location: 'Ciudad de México',
  image: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=400&h=400&fit=crop&crop=faces',
  result: 'Adiós a los sofocos nocturnos',
  quote: 'Los sofocos me despertaban 4 veces por noche. Apliqué el módulo del sueño y la suplementación, y en 3 semanas dormía completo. La neblina mental también desapareció.'
}, {
  name: 'Lucía Fernández',
  age: 55,
  location: 'Madrid, España',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=faces',
  result: 'Recuperé mi energía y claridad',
  quote: 'Sentía que tenía 80 años a los 54. Después de seguir el plan de 21 días recuperé energía, dejé el café por necesidad y volví a hacer cosas que disfrutaba. Es el mejor regalo que me he hecho.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="py-20 md:py-32 bg-cream relative overflow-hidden" data-id="element-321">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-322">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-323">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block py-1 px-3 rounded-full bg-sage-100 text-sage-800 text-xs font-semibold tracking-widest uppercase mb-6" data-id="element-324">
            Historias Reales
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-325">
            Mujeres que recuperaron su vida
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-charcoal-light" data-id="element-326">
            Más de <strong className="text-sage-700" data-id="element-327">3.200 mujeres</strong> ya
            transformaron su menopausia con este programa.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-328">
          {testimonials.map((t, index) => <motion.div key={index} variants={itemVariants} className="bg-cream-dark rounded-3xl p-7 md:p-8 relative shadow-sm hover:shadow-lg transition-shadow border border-sage-100" data-id="element-329">
              {/* Quote icon */}
              <Quote size={32} className="text-sage-300 absolute top-6 right-6 opacity-50" data-id="element-330" />

              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-331">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-yellow-400 fill-yellow-400" data-id="element-332" />)}
              </div>

              {/* Quote */}
              <p className="text-charcoal leading-relaxed mb-6 relative z-10" data-id="element-333">
                "{t.quote}"
              </p>

              {/* Result badge */}
              <div className="inline-flex items-center bg-sage-100 text-sage-800 px-3 py-1.5 rounded-full text-xs font-semibold tracking-wide mb-6" data-id="element-334">
                ✓ {t.result}
              </div>

              {/* Person */}
              <div className="flex items-center gap-3 pt-4 border-t border-sage-100" data-id="element-335">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover flex-shrink-0" data-id="element-336" />
                <div data-id="element-337">
                  <p className="font-semibold text-charcoal text-sm" data-id="element-338">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-xs text-charcoal-light/70" data-id="element-339">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Trust footer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-340">
          <div className="inline-flex items-center gap-2 bg-cream-dark border border-sage-100 rounded-full px-5 py-2" data-id="element-341">
            <div className="flex" data-id="element-342">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} className="text-yellow-400 fill-yellow-400" data-id="element-343" />)}
            </div>
            <span className="text-sm text-charcoal-light" data-id="element-344">
              <strong className="text-charcoal" data-id="element-345">4.9/5</strong> · Basado en 847
              reseñas verificadas
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}